module.exports = __webpack_public_path__ + "static/Gerda-blur-6e80c06ef6f693dfdd4cd79bcc8b415a.jpg";